import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroBanner from './components/HeroBanner';
import About from './components/About';
import MissionVision from './components/MissionVision';
import Products from './components/Products';
import Packaging from './components/Packaging';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import Memberships from './components/Memberships';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header scrolled={scrolled} />
      <HeroBanner />
      <About />
      <MissionVision />
      <Products />
      <Packaging />
      <WhyChooseUs />
      <Testimonials />
      <Memberships />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
